import { define } from '@components/Component.js'
import { h } from '@core/dom.js'
import { openLightbox } from '@components/shared/lightbox.js'

define('GoldGallery', ({ gallery = [], name }) => {
    const images = gallery.slice(0, 10)
    if (!images.length) return h('div', {})

    const mainImg = h('div', { className: 'gold-gallery__main' },
        h('img', {
            src:     images[0],
            alt:     `${name} foto 1`,
            loading: 'lazy'
        })
    )
    mainImg.addEventListener('click', () => openLightbox(images, 0))

    const sideImages = images.slice(1, 4)
    const remaining = images.length - 4

    const sideThumbs = sideImages.map((src, i) => {
        const isLast = i === sideImages.length - 1 && remaining > 0
        const thumb = h('div', {
            className: 'gold-gallery__thumb' + (isLast ? ' gold-gallery__thumb--more' : '')
        },
            h('img', { src, alt: `${name} foto ${i + 2}`, loading: 'lazy' })
        )
        if (isLast) thumb.setAttribute('data-remaining', '+' + remaining)
        thumb.addEventListener('click', () => openLightbox(images, i + 1))
        return thumb
    })

    const grid = h('div', { className: 'gold-gallery__grid' },
        mainImg,
        h('div', { className: 'gold-gallery__side' }, ...sideThumbs)
    )

    return h('div', { className: 'gold-gallery__wrap' }, grid)
})
